import request from '@/utils/request'
import axios from './index'

export function login (params) {
  return request.get('/HomePage')
}
export function logout () {
  return request.get('/logout')
}

export function modifyPassword (params) {
  return request.post('/modifyPassword', params)
}
/**
 * 查询网站配置
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectConfig (params) {
  return axios.post('/web_api/list', params)
}
/**
 * 查询网站配置
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function linksList (params) {
  return axios.post('/web_api/webList', params)
}
/**
 * 查询主营业务
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function webBusinessList (params) {
  return axios.post('/web_api/webBusinessList', params)
}
/**
 * 查询商务合作联系人
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function liaiseList (params) {
  return axios.post('/web_api/liaiseList', params)
}
/**
 * 首页客户案例查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeCaseList (params) {
  return axios.post('/web_api/homeCaseList', params)
}
/**
 * 合作伙伴查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function cooperativePartnerList (params) {
  return axios.post('/web_api/cooperativePartnerList', params)
}
/**
 * 首页查询埃文博士观点
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeDoctorList (params) {
  return axios.post('/web_api/homeDoctorList', params)
}
/**
 * 首页公司新闻中心
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeCompanyNewsList (params) {
  return axios.post('/web_api/homeCompanyNewsList', params)
}
/**
 * 首页行业新闻中心
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeIndustryNewsList (params) {
  return axios.post('/web_api/homeIndustryNewsList', params)
}
/**
 * 埃文简介
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectAboutEvan (params) {
  return axios.post('/web_api/selectAboutEvan', params)
}
/**
 * 热点分析
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectWebHotspotAnalysis (params) {
  return axios.post('/web_api/selectWebHotspotAnalysis', params)
}
/**
 * 政府案例查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeGovernmentCaseList (params) {
  return axios.post('/web_api/homeGovernmentCaseList', params)
}
/**
 * 企业案例查询
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function homeEnterpriseCaseList (params) {
  return axios.post('/web_api/homeEnterpriseCaseList', params)
}
/**
 * 公司新闻中心
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function webQueryAll (params) {
  return axios.post('/web_api/webQueryAll', params)
}
/**
 * 主营业务
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function businessTypeList (params) {
  return axios.post('/web_api/businessTypeList', params)
}
/**
 * 根据ID查询案例详情
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectCaseId (params) {
  return axios.post('/web_api/selectCaseId', params)
}
/**
 * 根据ID查询新闻详情
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectNewsId (params) {
  return axios.post('/web_api/selectNewsId', params)
}
/**
 * 新增碳排放管理与资讯
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function addExaminationStatistics (params) {
  return axios.post('/web_api/addExaminationStatistics', params)
}
/**
 * 滚动图
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectCarouselPicture (params) {
  return axios.post('/web_api/selectCarouselPicture', params)
}
/**
 * 查询视频
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectVideo (params) {
  return axios.post('/web_api/selectVideo', params)
}
/**
 * 荣誉分页
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function honorPage (params) {
  return axios.post('/web_api/honorPage', params)
}
/**
 * 专利
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectPatent (params) {
  return axios.post('/web_api/selectPatent', params)
}
/**
 * 问题列表
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectProblem (params) {
  return axios.post('/web_api/selectProblem', params)
}
/**
 * 新闻详情
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function newsDetails (params) {
  return axios.post('/web_api/newsDetails', params)
}
/**
 * 手机网页查询客户案例
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function selectMobileCaseId (params) {
  return axios.post('/web_api/selectMobileCaseId', params)
}
/**
 * 手机网页查询主营业务
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
export function webBusinessId (params) {
  return axios.post('/web_api/webBusinessId', params)
}
